import {FeatureFlagContextValue} from '@4r/module-common-feature-flags-mf-host';
import {getService} from "@4r/mf-app";

const decodeBase64 = (base64: string) =>
	typeof atob === 'undefined'
		? Buffer.from(base64, 'base64').toString('utf8')
		: atob(base64);

const parseJwt = (token: string) => {
	let base64Uri = token.split('.')[1];
	base64Uri = base64Uri.replace(/-/g, '+').replace(/_/g, '/');
	const jsonPayload = decodeURIComponent(
		decodeBase64(base64Uri) // Ensure node.js v16
			.split('')
			.map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
			.join(''),
	);
	return JSON.parse(jsonPayload);
};

const getValuesFromToken = async (userId: string): Promise<FeatureFlagContextValue[]> => {
	const userIdContextValue = {
		contextKey: 'userId',
		contextValue: userId,
	};

	const token = await getService('TokenService').getToken();
	if (!token) {
		return [];
	}

	const tokenObject = parseJwt(token);

	if (!tokenObject || !tokenObject.emails.length) {
		return [userIdContextValue];
	}

	return [userIdContextValue, {contextKey: 'email', contextValue: tokenObject.emails[0]}];
};

export default getValuesFromToken;
